import {
    MOMENTJS_DATE_DISPLAY_FORMAT,
    DATE_PICKER_DEFAULT_PRESETS,
} from '../../constants';
import { Moment } from 'moment';
import React from 'react';
import { FGButton, FGIcons } from '@fg/design-system';
import GQDateRangePicker from 'components/GQNavbar/GQDateRangePicker';
import moment from 'moment';

type Props = {
    maxDate: Moment;
    minDate: Moment;
    onChange: (startDate: Date, endDate: Date) => void;
    onClear: () => void;
};
const FeedDateFilter = React.memo(
    ({ maxDate, minDate, onChange, onClear }: Props) => {
        const hasDateRange = Boolean(minDate && maxDate);
        const label = hasDateRange
            ? `${minDate.format(
                  MOMENTJS_DATE_DISPLAY_FORMAT
              )} - ${maxDate.format(MOMENTJS_DATE_DISPLAY_FORMAT)}`
            : 'Date range';
        return (
            <div className="feed-date-filter">
                <GQDateRangePicker
                    initialStartDate={(
                        minDate?.clone() ||
                        moment()
                            .startOf('day')
                            .subtract(30, 'days')
                    ).toDate()}
                    initialEndDate={(
                        maxDate?.clone() || moment().startOf('day')
                    ).toDate()}
                    allowPresetSelectionOutOfRange={true}
                    presets={DATE_PICKER_DEFAULT_PRESETS}
                    onChange={onChange}
                    label={label}
                    trailingActions={
                        hasDateRange && (
                            <FGButton
                                variant="ghost"
                                size="xs"
                                aria-label="Reset date range"
                                title="Reset date range"
                                icon={
                                    <FGIcons
                                        icon="Remove"
                                        size={12}
                                        color="var(--fg-color-icon-muted)"
                                    />
                                }
                                onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    onClear();
                                }}
                            />
                        )
                    }
                />
            </div>
        );
    }
);

export default FeedDateFilter;
